<template>
  <div>
    <main-layout>
      <AdminMenu />
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12>
            <h1>{{ $t('member_dashboard') }}</h1>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark outline color="primary" :loading="loading" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs3 px-2>
                  <div class="caption">ชื่อ</div>
                  <input v-model="filter.full_name" type="text" placeholder="ชื่อ" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">ประเภทบัญชี</div>
                  <multiselect
                    v-model="filter.member_type"
                    :options="memberTypeOptions"
                    label="label"
                    track-by="value"
                    select-label
                    selected-label
                    placeholder="ประเภทบัญชี"
                  ></multiselect>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">เลขประจำตัวประชาชน</div>
                  <input
                    v-model="filter.identity_card_no"
                    type="text"
                    placeholder="เลขประจำตัวประชาชน"
                  />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">ชื่อโครงการ/หมู่บ้าน</div>
                  <input v-model="filter.project" type="text" placeholder="ชื่อโครงการ/หมู่บ้าน" />
                </v-flex>

                <v-flex xs12 class="text-xs-right">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed color="primary" @click="handleSearch">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="memberList"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template #items="props">
            <tr>
              <td>{{ handleGetRowNumber(props.index) }}</td>
              <td>{{ props.item.full_name || '-' }}</td>
              <td>
                <template v-if="props.item.member_type">
                  {{ getMemberTypeText(props.item.member_type) }}
                </template>
                <template v-else>-</template>
              </td>
              <td>{{ props.item.identity_card_no || '-' }}</td>
              <td>{{ props.item.project || '-' }}</td>
              <td>{{ props.item.assets.length || '-' }}</td>
              <td>
                <v-btn dark small color="primary" @click="handleShowDetails(props.item)">
                  {{ $t('view') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="changePage"
          ></v-pagination>
        </div>
      </v-container>

      <v-dialog v-model="showMemberDetailDialog" width="1000px" persistent>
        <MemberDetailDialog
          v-if="showMemberDetailDialog"
          v-model="selectedMember"
          @close="
            showMemberDetailDialog = false
            selectedMember = null
          "
          @input="handleMemberDetailInput"
        />
      </v-dialog>
    </main-layout>
  </div>
</template>

<script>
import juzmatchApi from '@/api/juzmatch'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'

import AdminMenu from './AdminMenu.vue'
import MemberDetailDialog from './MemberDetailDialog'
import { MEMBER_TYPE_OPTIONS } from '@/constants/juzmatch'

export default {
  components: {
    AdminMenu,
    Multiselect,

    MemberDetailDialog
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      memberList: [],
      headers: [
        { text: 'ลำดับที่', value: '', sortable: false },
        { text: 'ชื่อ', value: 'full_name', sortable: false },
        { text: 'ประเภทบัญชี', value: 'member_type', sortable: false },
        { text: 'เบอร์โทรศัพท์', value: 'identity_card_no', sortable: false },
        { text: 'ชื่อโครงการ / หมู่บ้าน', value: 'project', sortable: false },
        { text: 'จำนวนรหัสทรัพย์', value: 'period', sortable: false },
        { text: '', value: '', sortable: false }
      ],

      showAdvancedSearch: false,

      filter: {
        full_name: '',
        member_type: '',
        identity_card_no: '',
        project: ''
      },
      showMemberDetailDialog: false,
      selectedMember: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    memberTypeOptions() {
      return MEMBER_TYPE_OPTIONS.map((option) => ({
        value: option.value,
        label: this.$t(`juzmatch_member_type.${option.text}`)
      }))
    }
  },
  mounted() {
    this.handleGetMemberWithAsset()
  },
  methods: {
    async handleGetMemberWithAsset() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getMemberWithAsset()
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.memberList = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async getMemberWithAsset() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        Object.entries(vm.filter).forEach(([key, value]) => {
          if (value && Object.keys(value).length > 0) {
            Object.assign(data, { [key]: value.value })
          }
          if (value && value.length) {
            Object.assign(data, { [key]: value.toLowerCase() })
          }
        })

        const response = await juzmatchApi.getMemberWithAsset({
          config: {
            params: data
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getMemberWithAsset()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el, index) => {
          return {
            row_number: vm.handleGetRowNumber(index),
            fullname: el.full_name,
            member_type: vm.getMemberTypeText(el.member_type),
            identity_card_no: el.identity_card_no,
            project: el.project,
            asset_amount: el.assets.length || 0
          }
        })

        const heading = [
          [
            'ลำดับที่',
            'ชื่อจริง',
            'ประเภทบัญชี',
            'เบอร์โทรศัพท์',
            'ชื่อโครงการ / หมู่บ้าน',
            'จำนวนรหัสทรัพย์'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `member-dashboard.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleShowDetails(data) {
      this.selectedMember = data
      this.showMemberDetailDialog = true
    },

    handleSearch() {
      this.reset()
      this.handleCloseSearch()
    },
    handleClearSearch() {
      this.filter = {
        full_name: '',
        member_type: '',
        identity_card_no: '',
        project: ''
      }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetMemberWithAsset()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetMemberWithAsset()
    },

    handleGetRowNumber(idx) {
      let rowNumber = 0

      if (this.pageNumber > 1) {
        let tempNumber = parseInt(this.pageNumber - 1) * this.offset
        rowNumber = tempNumber + (idx + 1)
      } else {
        rowNumber = idx + 1
      }

      return rowNumber
    },
    handleMemberDetailInput(value) {
      this.memberList = this.memberList.map((item) => (item.id === value.id ? value : item))
    },
    getMemberTypeText(type) {
      const found = this.memberTypeOptions.find((option) => option.value === type)
      return found ? found.label : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberDashboard.vue